(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-faqs"] && !Shopify.designMode) return;
  try {
    
  /****************   JS for Category Switching   *********************/
  let elems = document.querySelectorAll(".category-heading");
  let index = 0, length = elems.length;
  for ( ; index < length; index++) {
    elems[index].onclick=function(){
      if(!this.classList.contains("active")){
        mainElem = this;
        let categoryElems = document.querySelectorAll(".category-heading");
        let categoryIndex = 0, categoryLength = categoryElems.length;
        for ( ; categoryIndex < categoryLength; categoryIndex++) {
          categoryElems[categoryIndex].classList.remove("active");
          categoryElems[categoryIndex].setAttribute("aria-expanded", "false");
        }
        this.classList.add("active");
        this.style.scrollMarginRight="30px"
        this.setAttribute("aria-expanded", "true");
        let ansElems = document.querySelectorAll(".faqs-ques-ans-container");
        let dataAttribute = "";
        let index = 0, length = ansElems.length;
        for ( ; index < length; index++) {
            ansElems[index].style.display = "none";
            dataAttribute = ansElems[index].getAttribute('data-categoryId');
            
            if(dataAttribute === mainElem.id){
              ansElems[index].style.display = "block";
            } else {
              ansElems[index].style.display = "none";
            }
        }
      } else{}
      window.scrollTo({
          top: 0,
          left: 0
        });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-ingredients"] && !Shopify.designMode) return;
  try {
    
  let isMobile = window.matchMedia("(max-width: 767px)").matches;

  
  window.addEventListener('load', (event) => {
  /*
  if (!isMobile){
    document.querySelector('.ingredients-item-container .ingredients-item:first-child .ingredient-image-wrap').classList.add('selected-ingredient')
  }
  
  document.querySelectorAll(".ingredient-info:not([data-index='1'])").forEach(item => item.classList.add('hide-ingredient') )
  */
  
    let ingredientItem = document.querySelectorAll('.ingredients-item')
    ingredientItem.forEach(item => {
      item.addEventListener('click', e => {
        let ingredient = item.getAttribute('data-value');

        if(isMobile){
          document.querySelector(".ingredients-mob-modal").style.display = 'block';
          let ingredient = item.getAttribute('data-value');
          let topPos = document.querySelector(`.ingredients-mob-modal .ingredient-info[data-value=${ingredient}]`).offsetTop;
          document.querySelector(".ingredients-mob-modal").scrollTop = topPos - 90;
        }else{
          document.querySelectorAll(".ingredient-info").forEach(item => item.classList.add('hide-ingredient') )
          document.querySelectorAll(".ingredient-info").forEach(item => item.classList.remove('show-ingredient') )
          document.querySelectorAll(".ingredient-image-wrap").forEach(item => item.classList.remove('selected-ingredient') )
          document.querySelector(`.ingredient-info[data-value=${ingredient}]`).classList.remove('hide-ingredient')
          document.querySelector(`.ingredient-info[data-value=${ingredient}]`).classList.add('show-ingredient')
          item.querySelector('.ingredient-image-wrap').classList.add('selected-ingredient')
        }
      })
    })
  
    if (isMobile) {
      document.querySelector('.close-ingredient-modal').addEventListener('click', e => {
        document.querySelector(".ingredients-mob-modal").style.display = 'none';
      })
  
      document.querySelector('.scroll-top-btn').addEventListener('click', e => {
        document.querySelector('.ingredients-mob-modal').scrollTop = 0
      })
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
